import React from "react";
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

export default function ChartScenarios() {
  // Výpočet: Pro 1000 platících uživatelů
  // CPPU (Cost per Paying User) x 1000 = Celkové náklady na marketing

  const data = [
    {
      scenario: "Konverze 30%",
      CPPU: 38,            // Cena za jednoho platícího uživatele
      DobaNavratnosti: 23, // Dny
      MarketingCost: 38000  // Celkové náklady při 1000 platících
    },
    {
      scenario: "Konverze 20%",
      CPPU: 57,
      DobaNavratnosti: 34,
      MarketingCost: 57000
    },
    {
      scenario: "Konverze 10%",
      CPPU: 114,
      DobaNavratnosti: 69,
      MarketingCost: 114000
    }
  ];

  const fontStyle = {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '16px'
  };

  return (
    <div style={fontStyle} className="p-4">
      <h2 className="text-2xl font-bold mb-4">Scénáře s pevnou cenou za získání zákazníka (CAC) 11,40 USD</h2>
      <div className="rounded-2xl shadow-lg bg-white p-2">
        <ResponsiveContainer width="100%" height={400}>
          <ComposedChart
            data={data}
            margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="scenario" tick={{ fontSize: 16 }} />
            <YAxis
              yAxisId="left"
              label={{ value: "USD", angle: -90, position: "insideLeft", style: { fontSize: 14 } }}
              tick={{ fontSize: 16 }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              label={{ value: "Dny", angle: 90, position: "insideRight", style: { fontSize: 14 } }}
              tick={{ fontSize: 16 }}
            />
            <Tooltip wrapperStyle={{ fontSize: '14px' }} />
            <Legend wrapperStyle={{ fontSize: '16px' }} />
            <Bar
              yAxisId="left"
              dataKey="CPPU"
              fill="#8884d8"
              name="CPPU (USD)"
              radius={[8, 8, 0, 0]}
            />
            <Bar
              yAxisId="left"
              dataKey="MarketingCost"
              fill="#82ca9d"
              name="Marketing (USD)"
              radius={[8, 8, 0, 0]}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="DobaNavratnosti"
              stroke="#ff7300"
              strokeWidth={3}
              dot={{ r: 5 }}
              name="Návratnost (dny)"
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <p className="mt-4" style={{ fontSize: '16px' }}>
        Tento graf zobrazuje tři scénáře (30%, 20%, 10%) při konstantní ceně 11,40 USD za přivedení jednoho neplatícího uživatele.
        <strong> CPPU (Cost per Paying User)</strong> představuje výslednou cenu za získání jednoho platícího uživatele v daném
        konverzním poměru, <strong>Marketing (USD)</strong> ukazuje celkové náklady na získání 1000 platících uživatelů
        (<em>CPPU × 1000</em>) a oranžová křivka znázorňuje <strong>dobu návratnosti</strong> (v dnech), pokud každý platící
        uživatel platí 99 USD měsíčně a nám reálně zůstává 49,50 USD.
      </p>
    </div>
  );
}

